/**
 * @generated SignedSource<<5b43f9c00144d754c33c17c3e5a0b986>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleTypesAssignTeamMutation$variables = {
  scheduleTypeIds: ReadonlyArray<string>;
  teamId: string;
};
export type EmployeeScheduleEditScheduleTypesAssignTeamMutation$data = {
  readonly team: {
    readonly setAssignedEmployeeScheduleTypes: {
      readonly id: string;
      readonly store: {
        readonly employeeScheduleTypes: ReadonlyArray<{
          readonly assignedTeams: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly id: string;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleTypesAssignTeam">;
      };
    } | null;
  };
};
export type EmployeeScheduleEditScheduleTypesAssignTeamMutation = {
  response: EmployeeScheduleEditScheduleTypesAssignTeamMutation$data;
  variables: EmployeeScheduleEditScheduleTypesAssignTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scheduleTypeIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "teamId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "scheduleTypeIds",
    "variableName": "scheduleTypeIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "setAssignedEmployeeScheduleTypes",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EmployeeScheduleEditScheduleTypesAssignTeam"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeScheduleType",
                    "kind": "LinkedField",
                    "name": "employeeScheduleTypes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeams",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TeamMutation",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "setAssignedEmployeeScheduleTypes",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeScheduleType",
                    "kind": "LinkedField",
                    "name": "employeeScheduleTypes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeams",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6761629b5ac6cc10cc8b9654d9a3d928",
    "id": null,
    "metadata": {},
    "name": "EmployeeScheduleEditScheduleTypesAssignTeamMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeScheduleEditScheduleTypesAssignTeamMutation(\n  $teamId: ID!\n  $scheduleTypeIds: [ID!]!\n) {\n  team(id: $teamId) {\n    setAssignedEmployeeScheduleTypes(scheduleTypeIds: $scheduleTypeIds) {\n      id\n      store {\n        ...EmployeeScheduleEditScheduleTypesAssignTeam\n        employeeScheduleTypes {\n          id\n          assignedTeams {\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment EmployeeScheduleEditScheduleTypesAssignTeam on Store {\n  employeeScheduleTypes {\n    id\n    ...EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType\n  }\n}\n\nfragment EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType on EmployeeScheduleType {\n  id\n  title\n  color\n  assignedTeams {\n    id\n    color\n    name\n    icon\n  }\n}\n"
  }
};
})();

(node as any).hash = "5031fe08b3758c437dd22b912e8d5602";

export default node;
